export default __webpack_public_path__ + "static/media/individual.4d56e157.svg";